(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-list"] && !Shopify.designMode) return;
  try {
    
  if (!window.YT) {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.async = true;
    document.head.appendChild(tag);
  }

  // 全局 API 回调
  window.onYouTubeIframeAPIReady = function () {
    // 不做事，等用户点击再创建播放器
  };

  // 判断是否移动端
  function isMobile() {
    return window.matchMedia('(max-width: 990px)').matches;
  }

  function getVideoHtml(id) {
    let youtubeHtml = `
        <iframe src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1"
            referrerpolicy='strict-origin-when-cross-origin'
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        `;
    return youtubeHtml;
  }

  // 处理播放器创建
  const createPlayer = (id) => {
    const initPlayer = () => {
      new YT.Player('youtube-player', {
        videoId: id,
        playerVars: { playsinline: 1 },
      });
    };

    // 如果 YouTube API 已加载，直接创建播放器
    if (window.YT && window.YT.Player) {
      initPlayer();
    } else {
      // 如果 API 尚未加载，等待 API 加载后再创建播放器
      window.onYouTubeIframeAPIReady = initPlayer;
    }
  };

  document.querySelectorAll('.video-li__poster').forEach(function (element) {
    element.addEventListener('click', function (event) {
      let video_type = this.dataset.type;

      // Shopify Video
      if (video_type == 'internal') {
        if (!element.classList.contains('active')) {
          element.classList.add('active');

          const video = element.querySelector('video');

          if (!video) return;

          video.play();
        }
      }

      // Youtube Video
      if (video_type == 'external') {
        let id = this.dataset.id;
        let sectionId = this.dataset.sectionId;

        // 移动端弹窗处理
        if (isMobile()) {
          const modal = document.getElementById('video-modal');
          const modalContent = document.getElementById('video-modal-content');

          modalContent.innerHTML = '<div id="youtube-player"></div>';
          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';

          // 隐藏分页
          const paginationBtn = document.querySelectorAll(`#shopify-section-${sectionId} .mobile_swiper_btn_group`)[0];
          if (paginationBtn) {
            paginationBtn.style.display = 'none';
          }

          // 创建播放器
          createPlayer(id);

          // 监听全屏退出
          document.addEventListener('fullscreenchange', () => {
            const playerEl = document.getElementById('youtube-player');
            if (document.fullscreenElement === playerEl && screen.orientation?.lock) {
              // 异步问题
              setTimeout(() => {
                screen.orientation.lock('landscape').catch(() => {});
              });
            }

            if (!document.fullscreenElement && screen.orientation?.unlock) {
              screen.orientation.unlock();
            }
          });

          return;
        }

        if (!element.classList.contains('active')) {
          element.innerHTML = getVideoHtml(id);
          element.classList.add('active');
        }
      }
    });
  });

  document.getElementById('video-modal').onclick = function (e) {
    // 只在点击背景时关闭（不关闭内容区域）
    if (e.target === this) {
      this.style.display = 'none';
      document.getElementById('video-modal-content').innerHTML = '';
      document.body.style.overflow = '';
      window.player = null;

      const els = document.closest('.mobile_swiper_btn_group');
      els.forEach((el) => {
        el.style.display = 'flex';
      });
    }
  };

  document.querySelectorAll('.video-li').forEach(function (element) {
    element.addEventListener('click', function (event) {
      if (!element.classList.contains('current')) {
        document.querySelectorAll('.video-li').forEach(function (element) {
          element.classList.remove('current');
        });
        element.classList.add('current');
      }
    });
  });

  var spaceBetween = parseInt($('.shopify-section--video-list .swiper-wrapper').css('gap')) || 10;
  var slidesPerView = window.matchMedia('(max-width: 750px)').matches ? 1 : columns_large || 4;
  var swiper = new Swiper('.shopify-section--video-list .swiper', {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    pagination: {
      el: '.shopify-section--video-list .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.shopify-section--video-list .swiper-button-next',
      prevEl: '.shopify-section--video-list .swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();
})();
